export default class Header {
  constructor() {
    this.selectors = {
      header: 'header',
      categoryMenu: '.blog-single-category .category-menu-section',
      searchWrapper: '.search-wrapper',
      menuToggler: '.header-menu-toggle-wrapper',
      defaultSize: 200,
      scrolledClass: 'scrolled',
      phoneWrapper: '.phone-main-wrapper',
      phoneLogo: '.phone-logo'
    }
    const { selectors: { header, searchWrapper, menuToggler, phoneLogo, phoneWrapper, categoryMenu } } = this
    this.header = document.querySelector(header)
    this.searchWrapper = this.header.querySelector(searchWrapper)
    this.menuToggler = this.header.querySelector(menuToggler)
    this.categoryMenu = document.querySelector(categoryMenu)
  }
  scrolledHeader() {
    if (this.header !== null) {
      document.addEventListener('scroll', () => {
        if (window.pageYOffset > this.selectors.defaultSize) {
          this.header.classList.add(this.selectors.scrolledClass)
          if (this.categoryMenu) {
            this.categoryMenu.classList.add('scrolled')
          }
        } else {
          this.header.classList.remove(this.selectors.scrolledClass)
          if (this.categoryMenu) {
            this.categoryMenu.classList.remove('scrolled')
          }
        }
      })
    }
  }
  searchToggle() {
    if (this.searchWrapper !== null) {
      const searchButton = this.searchWrapper.querySelector('.search-logo-wrapper')
      searchButton.addEventListener('click', () => {
        this.searchWrapper.classList.toggle('active')
      })
    }
  }
  mobileMenu() {
    if (this.menuToggler !== null) {
      this.menuToggler.addEventListener('click', () => {
        this.header.classList.toggle('active')
      })
    }
    const mainMenusItems = this.header.querySelectorAll('.main-level-menu-item')
    if (mainMenusItems) {
      Array.prototype.forEach.call(mainMenusItems, (mainMenusItem) => {

        const megaMenu = mainMenusItem.querySelector('.megamenu-main-wrapper')
        const toggler = mainMenusItem.querySelector('.main-level-menu-item-span')
        let closeMegamenu
        let closeSubmenu
        if (megaMenu) {
          megaMenu.addEventListener('mouseleave', () => {
            megaMenu.style.minHeight = 'unset'
          })
          const mainItems = megaMenu.querySelectorAll('.main-column-item')
          if (mainItems) {
            let hasSubCol = false
            Array.prototype.forEach.call(mainItems, (mainItem) => {
              const subCol = mainItem.querySelector('.sub-columns-main-wrapper')
              if (subCol) {
                if (window.matchMedia('(min-width:1200px)').matches) {
                  mainItem.addEventListener('mouseenter', () => {
                    //setTimeout(() => {
                      if (subCol.getBoundingClientRect().height > megaMenu.getBoundingClientRect().height) {
                        megaMenu.style.minHeight = `${subCol.getBoundingClientRect().height}px`
                      } else {
                        subCol.style.minHeight = `${megaMenu.getBoundingClientRect().height}px`
                      }
                    //}, 100)
                  })
                  mainItem.addEventListener('mouseleave', () => {
                    megaMenu.style.minHeight = `0`
                    subCol.style.minHeight = `0`
                  })
                }
                if (subCol.getBoundingClientRect().height > megaMenu.getBoundingClientRect().height) {
                  //megaMenu.style.minHeight = `${subCol.getBoundingClientRect().height}px`
                }
                hasSubCol = true
              }
            })
            if (hasSubCol) {
              megaMenu.classList.add('has-subcol')
            }
          }
          closeMegamenu = megaMenu.querySelector('.close-megamenu')
          closeSubmenu = megaMenu.querySelector('.close-submenu')
        }
        if (toggler) {
          if (closeSubmenu) {
            closeSubmenu.addEventListener('click', () => {
              Array.prototype.forEach.call(mainMenusItems, (mainMenusItem) => {
                mainMenusItem.classList.remove('active')
              })
            })
          }
          if (closeMegamenu) {
            closeMegamenu.addEventListener('click', () => {
              Array.prototype.forEach.call(mainMenusItems, (mainMenusItem) => {
                mainMenusItem.classList.remove('active')
              })
            })
          }
          toggler.addEventListener('click', () => {
            console.log(toggler)
            if (mainMenusItem.classList.contains('active')) {
              Array.prototype.forEach.call(mainMenusItems, (mainMenusItem) => {
                mainMenusItem.classList.remove('active')
              })
            } else {
              Array.prototype.forEach.call(mainMenusItems, (mainMenusItem) => {
                mainMenusItem.classList.remove('active')
              })
              mainMenusItem.classList.add('active')
            }
          })
        }
        if (megaMenu) {
          const megaMenuMenuItems = megaMenu.querySelectorAll('.main-column-item')
          if (megaMenuMenuItems) {
            Array.prototype.forEach.call(megaMenuMenuItems, (megaMenuMenuItem) => {
              const toggler = megaMenuMenuItem.querySelector('.mobile-toggler')
              toggler.addEventListener('click', () => {
                if (megaMenuMenuItem.classList.contains('active-sub')) {
                  Array.prototype.forEach.call(megaMenuMenuItems, (megaMenuMenuItem) => {
                    megaMenuMenuItem.classList.remove('active-sub')
                  })
                } else {
                  Array.prototype.forEach.call(megaMenuMenuItems, (megaMenuMenuItem) => {
                    megaMenuMenuItem.classList.remove('active-sub')
                  })
                  megaMenuMenuItem.classList.add('active-sub')
                }
              })
  
              const subColumns = megaMenuMenuItem.querySelectorAll('.sub-column-wrapper')
              if (subColumns) {
                Array.prototype.forEach.call(subColumns, (subColumn) => {
                  const titleWrapper = subColumn.querySelector('.title-wrapper')
                  if (titleWrapper) {
                    titleWrapper.addEventListener('click', () => {
                      if (subColumn.classList.contains('show-column')) {
                        Array.prototype.forEach.call(subColumns, (subColumn) => {
                          subColumn.classList.remove('show-column')
                        })
                      } else {
                        Array.prototype.forEach.call(subColumns, (subColumn) => {
                          subColumn.classList.remove('show-column')
                        })
                        subColumn.classList.add('show-column')
                      }
                    })
                  }
                })
              }
            })
          }
        }
      })
    }
    // const childrenMenus = this.header.querySelectorAll('.menu-item-has-children')
    // if (childrenMenus) {
    //   Array.prototype.forEach.call(childrenMenus, (childMenu) => {
    //     childMenu.addEventListener('click', () => {
    //       if (childMenu.classList.contains('active')) {
    //         childMenu.classList.remove('active')
    //       } else {
    //         Array.prototype.forEach.call(childrenMenus, (childMenu) => {
    //           childMenu.classList.remove('active')
    //         })
    //         childMenu.classList.add('active')
    //       }
    //     })
    //   })
    // }
    const caseWrappers = document.querySelectorAll('header .casestudy-wrapper')
    const iframeElem = document.createElement('iframe')
    Array.prototype.forEach.call(caseWrappers, (caseWrapper) => {
      const videoOpen = caseWrapper.querySelector('.logo-wrapper')
      const popupWrapper = document.querySelector('.header-video-popup-wrapper')
      const videoId = caseWrapper.getAttribute('data-video-id')
      const iframeWrapper = document.querySelector('header .iframe-wrapper')
      // if (iframeWrapper) {
      //   iframeWrapper.remove()
      // }
      let isRan = false
      videoOpen.addEventListener('click', () => {
        if (videoOpen.classList.contains('no-video')) {
          return
        }
        const innerIframes = popupWrapper.querySelectorAll('iframe')
        if (innerIframes) {
          Array.prototype.forEach.call(innerIframes, (innerIframe) => {
            innerIframe.remove()
          })
        }
        document.body.classList.add('header-iframe-open')
        popupWrapper.appendChild(iframeWrapper)
        document.querySelector('header').classList.add('open')
        iframeElem.setAttribute('width', '560')
        iframeElem.setAttribute('height', '315')
        iframeElem.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1`)
        iframeElem.setAttribute('title', 'YouTube video player')
        iframeElem.setAttribute('frameborder', '0')
        iframeElem.setAttribute('autoplay', '1')
        iframeElem.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture')
        iframeElem.setAttribute('allowfullscreen', '')
    
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/player_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        var player;
        function onYouTubePlayerAPIReady() {
          player = new YT.Player('.video-popup-frame', {
            height: '360',
            width: '640',
            videoId: videoId,
            autoplay: 1
          });
        }
        if (!isRan) {
          iframeWrapper.appendChild(iframeElem)
        }
        isRan = true
      })
      popupWrapper.addEventListener('click', (e) => {
        const iframeWrapper = document.querySelector('header .iframe-wrapper')
        if (e.target !== iframeWrapper) {
          document.body.classList.remove('header-iframe-open')
          document.querySelector('header').classList.remove('open')
          iframeWrapper.remove()
        }
      })
    })
  }
  addClassIfCategory() {
    if (this.categoryMenu) {
      document.body.classList.add('has-category-menu')
    }
  }
}

function descHider() {
  const mainColumns = document.querySelectorAll('.main-column')
  if (mainColumns) {
    let maxHeight = window.innerHeight - document.querySelector('header').getBoundingClientRect().height
    Array.prototype.forEach.call(mainColumns, (mainColumn) => {
      mainColumn.classList.remove('hidden-desc')
    })
    Array.prototype.forEach.call(mainColumns, (mainColumn) => {
      if (maxHeight < mainColumn.getBoundingClientRect().height) {
        mainColumn.classList.add('hidden-desc')
      } else {
        mainColumn.classList.remove('hidden-desc')
      }
    })
  }
}
document.addEventListener('DOMContentLoaded', () => {
  descHider()
})
window.addEventListener('scroll', () => {
  descHider()
})
window.addEventListener('resize', () => {
  descHider()
})
//document.addEventListener('DOMContentLoaded', () => {
    const animWrapper = document.querySelector('.animation-wrapper')
    if (animWrapper) {
      const animVideo = animWrapper.querySelector('video')
      let animIsRan = sessionStorage.getItem('animation_ran')
      if (animIsRan !== 'true') {
        sessionStorage.setItem('animation_ran', 'true')
      } else {
        animWrapper.classList.add('anim-ran')
      }
    }
//})

// const linkHeaderWrappers = document.querySelectorAll('header .sub-title-item')
// if (linkHeaderWrappers) {
//   Array.prototype.forEach.call(linkHeaderWrappers, (linkHeaderWrapper) => {
//     const innerLink = linkHeaderWrapper.querySelector('a')
//     const newLink = document.createElement('span')
//     newLink.innerHTML = innerLink.innerHTML
//     linkHeaderWrapper.replaceChild(newLink, innerLink)
//   })
// }

// const linksToChangeFromA = document.querySelectorAll('header .remove-a-tag')
// if (linksToChangeFromA) {
//   Array.prototype.forEach.call(linksToChangeFromA, (link) => {
//     const innerLinks = link.querySelectorAll('a')[0]
//     const newLink = document.createElement('span')
//     newLink.innerHTML = innerLinks.innerHTML
//     link.replaceChild(newLink, innerLinks)
//     // const newLink = document.createElement('span')
//     // newLink.innerHTML = innerLink.innerHTML
//     // linkHeaderWrapper.replaceChild(newLink, innerLink)
//   })
// }